import { render, staticRenderFns } from "./WatchSpot.vue?vue&type=template&id=6dea247f&scoped=true"
import script from "./WatchSpot.vue?vue&type=script&lang=js"
export * from "./WatchSpot.vue?vue&type=script&lang=js"
import style0 from "./WatchSpot.vue?vue&type=style&index=0&id=6dea247f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea247f",
  null
  
)

export default component.exports